/*
 * Format-generation progress.
 *
 * A multi-format banner draw reports real per-slot progress: the backend streams (and persists)
 * `completed / total` as each of the ~14 formats lands, so the bar reflects true state and, because
 * the counts are persisted and replayed on reconnect, survives a reload mid-run instead of resetting.
 * This is a pure mapping from those counts to a 0..100 width; the ProgressBar's own width transition
 * eases between the (unevenly timed) slot jumps.
 */

/** 0..100 fill for `completed` of `total` formats. Clamped; 0 when the total is not yet known. */
export const formatProgressPct = (completed: number, total: number): number => {
  if (!Number.isFinite(total) || total <= 0) return 0;
  const done = Number.isFinite(completed) ? completed : 0;
  return Math.max(0, Math.min(100, Math.round((done / total) * 100)));
};
